import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import TopNav from './navigation/TopNav';

interface PublicLayoutProps {
  children?: ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopNav />
      <main className="max-w-7xl mx-auto p-6">
        {children || <Outlet />}
      </main>
    </div>
  );
}